import { render, staticRenderFns } from "./FinalizarAvisosSaldoItemContrato.vue?vue&type=template&id=2f08d606"
import script from "./FinalizarAvisosSaldoItemContrato.vue?vue&type=script&lang=js"
export * from "./FinalizarAvisosSaldoItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports